//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        website: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        galleryName: {
            type: String,
            default: 'main'
        },
        changeMethod: {
            type: String,
            default: ''
        },
        image: null,
        mediaFolder: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            imageData: null,
            uploadFieldName: '',
            showMediaGallery: false
        };
    },

    methods: {
        chooseImage: function chooseImage() {
            //this.$refs.fileInput.click()
        },
        onSelectFile: function onSelectFile(event) {
            var _this = this;

            var input = this.$refs.fileInput;
            var files = input.files;
            if (files && files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    _this.imageData = e.target.result;
                };
                reader.readAsDataURL(files[0]);
                this.$emit('input', files[0]);
            }
        },
        emitAction: function emitAction(event) {
            this.$emit(this.changeMethod, event);
        },
        openMediaGallery: function openMediaGallery() {
            Event.$emit('view-folder', this.galleryName);
            this.closeMediaGallery();
            console.log('openMediaGallery ' + this.galleryName);
            this.showMediaGallery = true;
        },
        closeMediaGallery: function closeMediaGallery() {
            Event.$emit('close-media-slideout');
            console.log('closeMediaGallery ' + this.galleryName);
            this.showMediaGallery = false;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var $el = this;

        if ($el.image) {
            $el.imageData = $el.image.url;
        }
        Event.$on('img-uploader-upload-success', function () {
            if (_this2.showMediaGallery == true) {
                _this2.showMediaGallery = false;
            } else {
                _this2.showMediaGallery = true;
            }
            if (_this2.image) {
                _this2.imageData = _this2.image.url;
            }
        });

        Event.$on('img-uploader-hide-media-gallery', function () {
            _this2.showMediaGallery = false;
            if (_this2.image) {
                _this2.imageData = _this2.image.url;
                console.log('img-uploader-hide-media-gallery Setting imageData to ' + _this2.image.url);
                console.log(_this2.image);
            }
        });

        Event.$on('show-existing-image', function (fileURL) {
            console.log('show-existing-image Setting imageData to ' + fileURL);
            $el.imageData = fileURL;
            console.log(_this2.image);
        });

        Event.$on('show-upload-image', function () {
            console.log('show-upload-image Setting imageData to false');
            $el.imageData = null;
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/ImageUploader.vue
// module id = BmTH
// module chunks = 0 1